<template>
  <div class="line" :class="{'line2':getTaskListDataLength==2}">
    <div 
      v-if="isShowText"
      class="bubble" 
      :class="{'bubble2':isTwoTask}"
      :style="PositionStyleData"
    >
    <div
      class="desc"
      :class="{'desc2':isTwoTask, 'desc3':country=='BR'}"
      ref="lineDesc"
    >{{ betweenNextFocusNode.text }}</div>
    <div
      class="triangle"
      v-if="isShowTriangle"
      :style="{
        backgroundImage: 'url(' + triangle + ')',
      }"
    ></div>
 </div>
    <div 
     :class="getCurrentSchedule"
     :style="{ width: currentSchedule }"
     ></div>
  </div>
</template>
<script>
import TRIANGLE from '@/assets/images/oldCustomer/triangle.png'
import TRIANGLE99 from '@/assets/images/oldCustomer/99_triangle.png'
Object.freeze(TRIANGLE)
Object.freeze(TRIANGLE99)

export default {
  props: {
    classIndex: {
      default: 0
    },
    betweenNextFocusNode: {
      default: () => {}
    },
    getTaskListDataLength: {
      default: 0
    }
  },
  computed: {
    getCurrentSchedule () {
      return `current-schedule current-schedule${this.classIndex}`
    },
    country () {
      return this.$store.state.country
    },
    currentSchedule () {
      if (this.betweenNextFocusNode) {
        return (
          Math.round(
            (this.betweenNextFocusNode.completedLadderNum /
              this.betweenNextFocusNode.totalLadderNum) *
              10000
          ) /
            100.0 +
          '%'
        )
      } else {
        return '0%'
      }
    },
    isShowText () {
      return (
        this.betweenNextFocusNode &&
        this.betweenNextFocusNode.completedLadderNum &&
        this.betweenNextFocusNode.completedLadderNum <
          this.betweenNextFocusNode.totalLadderNum &&
        this.betweenNextFocusNode.text
      )
    },
    triangle () {
      if (this.country === 'BR') {
        return TRIANGLE99
      } else {
        return TRIANGLE
      }
    },

    isTwoTask () {
      return this.getTaskListDataLength == 2 // eslint-disable-line
    }
  },
  watch: {
    bubbleWidth () {
      this.PositionStyle()
    },
    lineWidth () {
      this.PositionStyle()
    },
    currentScheduleWidth () {
      this.PositionStyle()
    }
  },
  data () {
    return {
      bubbleWidth: 0, // 气泡宽度
      lineWidth: 0, // 线宽度
      currentScheduleWidth: 0, // 进度宽度
      isShowTriangle: true,
      PositionStyleData: {}
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.isShowText) {
        const bubble = document.querySelector('.line .bubble').getBoundingClientRect() || {}
        const className = `.line .current-schedule${this.classIndex}`
        const currentSchedule = document.querySelector(className).getBoundingClientRect() || {}
        const line = document.querySelector('.line').getBoundingClientRect() || {}

        this.bubbleWidth = bubble.width
        this.lineWidth = line.width
        this.currentScheduleWidth = currentSchedule.width
      }
    })
  },
  methods: {
    PositionStyle () {
      if (this.bubbleWidth * 0.5 > this.currentScheduleWidth) {
        this.isShowTriangle = false
        this.PositionStyleData = {
          left: '0'
        }
      } else if (this.bubbleWidth * 0.5 > this.lineWidth - this.currentScheduleWidth) {
        this.isShowTriangle = false
        this.PositionStyleData = {
          left: 'auto',
          right: '0'
        }
      } else {
        this.PositionStyleData = {
          left: this.currentScheduleWidth - (this.bubbleWidth * 0.5) + 'px'
        }
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/variables"
.line
    position absolute
    left 0
    top 0
    width 160px
    height 12px
    background #F5F5F7
    border-radius 8px
.line2
    width 240px
.current-schedule
    border-radius 8px
    height 12px
    background #FF7A45
    border-radius 8px
    background-primary-color()

.bubble
    position absolute
    top -60px
    max-width 160px
.bubble2
    max-width: 240px
.desc
    background-primary-color()
    overflow hidden
    white-space: nowrap;
    text-overflow: ellipsis;
    height 40px
    line-height 40px
    text-align center
    border-radius 8px
    font-family 'Aspira Medium'
    font-size 24px
    color #FFFFFF
    font-weight 500
    padding 0 12px
    max-width 160px
.desc2
    max-width: 240px
.desc3
    color: #000
.triangle
    width 14px
    height 6px
    background-size 100% 100%
    margin 0 auto

</style>
